module.exports = __webpack_public_path__ + "static/media/pickup.811cba1b.svg";